import React, { useEffect, useState } from "react";
import "../dashboard.scss";
import { AgGridReact } from "ag-grid-react";
import { studentalumini } from "../../../services/student";
import moment from "moment";
import { academylist } from "../../../services/admin";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import { stuacademicyearlist } from "../../../services/master";

export default function Allalumini() {
  const [filterProduct, setFilterProduct] = useState([]);
  const [ayear, setAYear] = useState("");
  const [alist, setAList] = useState([]);
  const navigate = useNavigate();
  const columnDefs = [
    {
      headerName: "Actions",
      width: 100,
      field: "student_id",
      resizable: true,
      filter: false,
      cellRenderer: function (params) {
        return (
          <div className="text-center">
            <a
              onClick={() => navigate(`/student/profile/${params.value}`)}
              className="btn-sm btn-success"
              title="Student Profile"
            >
              <i className="fa fa-user"></i>
            </a>
          </div>
        );
      },
    },

    {
      headerName: "Username",
      field: "username",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Name",
      field: "name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Phone",
      field: "phone",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Class",
      field: "class_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Gender",
      field: "gender",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Left Date",
      field: "left_date",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
      CellRenderer: function (params) {
        return moment(params.value).format("DD-MM-YYYY");
      },
    },
  ];

  const columnADefs = [
    {
      headerName: "Actions",
      width: 100,
      field: "student_id",
      resizable: true,
      filter: false,
      cellRenderer: function (params) {
        return (
          <div className="text-center">
            <a
              onClick={() => navigate(`/student/profile/${params.value}`)}
              className="btn-sm btn-success"
              title="Student Profile"
            >
              <i className="fa fa-user"></i>
            </a>
          </div>
        );
      },
    },
    {
      headerName: "Username",
      field: "username",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Name",
      field: "name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Phone",
      field: "phone",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Class",
      field: "class_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Gender",
      field: "gender",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Left Date",
      field: "left_date",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
      CellRenderer: function (params) {
        return moment(params.value).format("DD-MM-YYYY");
      },
    },

    {
      headerName: "Academy",
      field: "academy_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
  ];

  const [aclist, setACList] = useState([]);
  const [acaid, setAcaID] = useState("");
  useEffect(() => {
    academylist().then((res) => {
      if (res.status === true) {
        let arr = [];
        if (res.data.details.length > 0) {
          for (let i = 0; i < res.data.details.length; i++) {
            arr.push({
              value: res.data.details[i].id,
              label:
                res.data.details[i].name + " - " + res.data.details[i].code,
            });
          }
          setACList(arr);
        }
      }
    });
    if (localStorage.getItem("AAcademy") != null) {
      academylist().then((res) => {
        if (res.status === true) {
          let arr = [];
          if (res.data.details.length > 0) {
            for (let i = 0; i < res.data.details.length; i++) {
              if (res.data.details[i].id == localStorage.getItem("AAcademy")) {
                arr.push({
                  value: res.data.details[i].id,
                  label:
                    res.data.details[i].name + " - " + res.data.details[i].code,
                });
              }
              if (arr.length > 0) {
                setAcaID(arr[0]);
                listall(arr[0], '');
              }
            }

          }
        }
      });
    }
  }, []);

  function listall(aid, yrs) {
    setFilterProduct([]);
    const temp = new FormData();
    if (aid !== '') {
      temp.append("academy_id", aid.value);
    }
    studentalumini(temp).then((res) => {
      if (res.status === true) {
        if (yrs !== '') {
          const ddata = res.data.details.filter((item) => item.year == yrs);
          setFilterProduct(ddata);
        } else {
          setFilterProduct(res.data.details);
        }
      }
    });

    stuacademicyearlist(temp).then((res) => {
      if (res.status === true) {
        let arr = [];
        if (res.data.length > 0) {
          for (let i = 0; i < res.data.length; i++) {
            arr.push({
              value: res.data[i].id,
              label: res.data[i].aca_year,
            });
          }
          setAList(arr);
        }
      }
    });
  }
  function handleAcademy(e) {
    setAYear("");
    if (e !== null) {
      setAcaID(e);
      listall(e, ayear)
    } else {
      setAcaID("");
      listall("", ayear)
    }
  }

  function downloadexcel() {
    let aca = ''
    if (localStorage.getItem("Role") === "1" && acaid !== "") {
      aca = acaid.value
    } else if (localStorage.getItem("Role") !== "1") {
      aca = localStorage.getItem("academy")
    }
    const reportUrl = localStorage.getItem("reportUrl");
    window.open(reportUrl + 'report/studentreport?academy_id=' + aca + '&student_id=' + '' + '&class_id=' + '' + '&section_id=' + '' + '&year_id=' + ayear + '&active=' + 2, "_blank");

  }

  return (
    <div>
      <div className="page-header">
        <h2 className="main-content-title tx-24 mg-b-5">All Alumni</h2>
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <a>Alumni Management</a>
          </li>
          <li className="breadcrumb-item active" aria-current="page">
            All Alumni
          </li>
        </ol>
      </div>
      <div className="content-body">
        <div className="container-fluid">
          <div className="row">
            <div className="col-xl-12">
              <div className="card">
                <div className="card-body">
                  <div className="row">
                    {localStorage.getItem("Role") === "1" && (
                      <div className="col-xl-4 col-sm-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Select Academy <span className="text-danger"> *</span>
                          </label>
                          <Select
                            className="default-select"
                            placeholder="Select Academy"
                            value={acaid}
                            options={aclist}
                            onChange={handleAcademy}
                            isSearchable={true}
                            isClearable
                            hidden
                          />
                        </div>
                      </div>
                    )}

                    <div className="col-xl-4 col-sm-6">
                      <div className="mb-3">
                        <label className="form-label">
                          Academic Year
                        </label>
                        <select
                          className="default-select form-control wide"
                          onChange={(e) => {
                            setAYear(e.target.value);
                            listall(acaid, e.target.value);
                          }}
                          value={ayear}
                        >
                          <option value="" disabled>
                            Select Academic Year
                          </option>
                          {alist.map((item) => (
                            <option value={item.value} key={item.value}>
                              {item.label}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                     <div className="col-xl-4 col-sm-6">
                    <div className="res-right mt-5">
                      <button className="btn btn-success me-2" onClick={downloadexcel}>
                        Excel Download
                      </button>

                    </div>
                  </div>
                  </div>
                 
                  <div className="ag-theme-alpine ag-style mt-2">
                    {localStorage.getItem("Role") === "1" &&
                      <AgGridReact
                        columnDefs={columnADefs}
                        rowData={filterProduct}
                        pagination="true"
                        paginationPageSize="10"
                        sortingOrder={["asc", "desc"]}
                        suppressDragLeaveHidesColumns={true}
                      />
                    }
                    {localStorage.getItem("Role") !== "1" &&
                      <AgGridReact
                        columnDefs={columnDefs}
                        rowData={filterProduct}
                        pagination="true"
                        paginationPageSize="10"
                        sortingOrder={["asc", "desc"]}
                        suppressDragLeaveHidesColumns={true}
                      />
                    }

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
